import React from "react";
import "./CoConnectHub.css";

/*
  CoConnectHub is a SIDEBAR-CONTROLLED page.
  Navigation must use setCurrentView, not react-router navigate.
*/

export default function CoConnectHub({
  setCurrentView,
  accountType,
  signedInAs,
}) {
  const showIndividualCards =
    accountType !== "Professional" || signedInAs !== "Professional";

  return (
    <div className="cch-container">
      <img
        src={(process.env.PUBLIC_URL || "") + "/Icon-CoC-Blue.png"}
        alt="Logo"
        style={{
          width: "100%",
          maxWidth: 200,
          height: "auto",
          display: "block",
          margin: "-50px auto 0 auto",
        }}
      />
      <h1 className="cch-title">CoConnect™</h1>
      <p className="cch-subtitle">
        A space to grow, share, and uplift others through community.
      </p>

      <div className="cch-pillars">
        <div
          className="cch-card"
          onClick={() => setCurrentView("ManageConnections")}
        >
          <img
            className="cch-card-icon"
            src={(process.env.PUBLIC_URL || "") + "/Icon-PC-Blue.png"}
            alt="Professional Connections icon"
          />
          <h2 className="cch-card-title">Professional Connections</h2>
          <p className="cch-card-text">
            Invite your professional team to support your journey.
          </p>
          <button className="cch-button">Invite Your Team</button>
        </div>

        {showIndividualCards && (
          <>
            {/* Communities */}
            <div
              className="cch-card"
              onClick={() => setCurrentView("Communities")}
            >
              <img
                className="cch-card-icon"
                src={(process.env.PUBLIC_URL || "") + "/Icon-JoinCom-Blue.png"}
                alt="Join Communities icon"
              />
              <h2 className="cch-card-title">Join Health Communities</h2>
              <p className="cch-card-text">
                Find your circles that nourish your growth.
              </p>
              <button className="cch-button">Explore Communities</button>
            </div>

            {/* Community Activity */}
            <div
              className="cch-card"
              onClick={() => setCurrentView("CommunityActivity")}
            >
              <img
                className="cch-card-icon"
                src={(process.env.PUBLIC_URL || "") + "/Icon-Comm-Blue.png"}
                alt="Share and Encourage icon"
              />
              <h2 className="cch-card-title">Share &amp; Encourage</h2>
              <p className="cch-card-text">
                Share your journey and uplift others along theirs.
              </p>
              <button className="cch-button">Share Your Progress</button>
            </div>

            {/* Personal Progress */}
            <div
              className="cch-card"
              onClick={() => setCurrentView("PersonalProgress")}
            >
              <img
                className="cch-card-icon"
                src={(process.env.PUBLIC_URL || "") + "/Icon-PP-Blue.png"}
                alt="View Your Progress icon"
              />
              <h2 className="cch-card-title">View Your Progress</h2>
              <p className="cch-card-text">
                Track your growth through the seasons.
              </p>
              <button className="cch-button">View Your Progress</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
